import { Box, Dialog, DialogContent, TextField } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import ClearButton from "components/buttons/ClearButton"
import SearchButton from "components/buttons/SearchButton"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { jobOrderApiNm, jobOrderColNm } from "constants/jobOrderConstant"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useState } from "react"
import { addIdForDataGrid } from "utils"
import { jobOrderListColumns } from "./columns"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { branchApiNm } from "branch/constant/branchApiNm"
import { pritnJoborderData } from "./printJobOrderData"

const clearFilterData = {
  ContNo: null,
  JobNo: null,
  JobOrdId: null
}
const JobOrderListDialog = ({ selectedId, dialogOpen, setDialogOpen, onFinish }) => {

  const { ax, msData } = useContext(GlobalStateContext)
  const [filterData, setFilterData] = useState({ ...clearFilterData })
  const [dataTable, setDataTable] = useState([])

  const getData = useCallback((filter) => {
    ax.post(jobOrderApiNm.getJobOrder, filter).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, "JobOrdId"))
      }
    })
  }, [ax])

  const textFieldProps = useCallback((name) => ({
    size: "small",
    label: jobOrderColNm[name],
    value: filterData[name] || "",
    onChange: (e) => setFilterData(o => ({ ...o, [name]: e.target.value || null })),
    onKeyUp: (e) => { if (e.key === "Enter") getData(filterData) }
  }), [filterData, getData])


  const handleCellClick = useCallback(({ field, row }) => {
    if (field === "Print") {
      ax.post(branchApiNm.getPrintJobOrderData, { JobOrdId: row.JobOrdId}).then(value => {
        if (value.data && value.data) {
          const joData = {
            ...value.data.JOData,
            PCItems: value.data.PCItems,
            SExps: value.data.SExps
          }
          pritnJoborderData({ joData: joData, msData })
        }
      })
    }
  }, [ax, msData])

  useEffect(() => {
    if (!dialogOpen) {
      setDataTable([])
      setFilterData({ ...clearFilterData })
      return
    }
  }, [dialogOpen, ax])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='lg'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="ค้นหาใบงาน"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} >
          <BoxFR>
            <Box flex={1} />
            <TextField {...textFieldProps("JobNo")} sx={{ width: 150 }} />
            <TextField {...textFieldProps("ContNo")} sx={{ width: 150 }} />
            <TextField {...textFieldProps("JobOrdId")} sx={{ width: 150 }} />
            <SearchButton onClick={() => getData(filterData)} />
            <ClearButton onClick={() => setFilterData({ ...clearFilterData })} />
          </BoxFR>
          <Box height={400}>
            <DataGridCellExpand
              density="compact"
              hideFooter
              rows={dataTable}
              columns={jobOrderListColumns}
              onCellClick={handleCellClick}
            />
          </Box>
        </BoxFC>
      </DialogContent>
      <DialogFooter okText={""}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null} />
    </Dialog>
  )
}

export default React.memo(JobOrderListDialog)